exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table{font-family:arial,sans-serif;font-size:13px;border:1px solid #cdcdcd;border-collapse:collapse;width:100%}td,th{text-align:left;padding:8px}th:hover{background-color:#efeeee;cursor:pointer}tr:nth-child(2n){background-color:#ddd}", ""]);

// exports
